import React, { useContext } from 'react';

import { Navigate } from 'react-router';

import {
    useRouter,
    useScoreData,
} from '../../hooks';
import { FirebaseContext } from '../../providers';
import { PageContext } from '../../routes/Page';
import { isEmptyObject } from '../../utils';
import { Loader } from '../Loader';
import { MainLayout } from '../MainLayout';

export const LayoutDefault: React.FC = ({ children }) => {
    const { currentPageData } = useContext(PageContext);
    const { scoreData, isDataLoading } = useScoreData();

    const { user } = useContext(FirebaseContext);

    const { pathname } = useRouter();

    const { hide_footer: hideFooter, calculateMinHeight } =
        currentPageData.content;

    if (isDataLoading) return <Loader centered />;

    if (user && pathname === '/check-score' && !isEmptyObject(scoreData)) {
        return <Navigate to="myscore" replace />;
    }

    if (pathname === '/check-score' && !user) {
        return <Navigate to="login" replace />;
    }

    return (
        <MainLayout
            hideFooter={hideFooter}
            calculateMinHeight={calculateMinHeight}
        >
            {children}
        </MainLayout>
    );
};
